<div class="container">
  <form>
    <p 
      *ngIf="recoverRefuelData.action === 'Refuel'" 
      class="informational-text-dialog" 
      mat-dialog-title>
      <span>
        Confirm Generator Refuel <span class="d-block">was Completed</span>
      </span>
    </p>
    <p 
      *ngIf="recoverRefuelData.action === 'Recover'" 
      class="informational-text-dialog" 
      mat-dialog-title>
      <span>
        Confirm Generator Recovery <span class="d-block"> From Power Supply</span>
      </span>
    </p>
    <div class="d-flex justify-content-center">
      <mat-dialog-actions>
        <button
          class="dialog-action-button confirm-button-color"
          color="primary"
          mat-raised-button
          (click)="refuelRecoverConfirm(recoverRefuelData.action)">
          Confirm
        </button>
        <button
          class="dialog-action-button cancel-button-color"
          mat-dialog-close
          mat-raised-button
          type="button">
          Cancel
        </button>
      </mat-dialog-actions>
    </div>
  </form>
</div>
